module.exports = __webpack_public_path__ + "static/media/telegram-logo.1264888d.svg";